import React from "react";
import { Card, Typography, withStyles, Grid } from "@material-ui/core";
import styles from "./styles";
import { BrandColors } from "../../../styles/BrandColors";

const SingleValueCard = (props) => {
  const { classes, label, valueColor, value } = props;
  return (
    <Card className={classes.cardContainer} variant="outlined" elevation={0}>
      <Grid container spacing={2} justify="center" alignItems="center">
        <Grid item>
          {!isNaN(value) && <Grid container direction="column" alignItems="center">
            <Grid item>
              <Typography
                variant="h2"
                component="h2"
                style={{
                  color: valueColor ? valueColor : BrandColors.JLLBrandColors.Black.tint50Percent
                }}
              >
                {value}
              </Typography>
            </Grid>
            <Grid item>
              <Typography>{label}</Typography>
            </Grid>
          </Grid>}
        </Grid>
      </Grid>
    </Card>
  );
};

export default withStyles(styles, { withTheme: true })(SingleValueCard);
